import script from "./ActivationWhatsappPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationWhatsappPage.vue?vue&type=script&setup=true&lang=js"

import "./ActivationWhatsappPage.vue?vue&type=style&index=0&id=442de8c3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-442de8c3"]])

export default __exports__